import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { uniqueId, isNull } from 'lodash';
import classNames from 'classnames';
import Image from '@fhs/shared/src/components/Image/Image';
import './DesaturateImage.scss';

const DesaturateImage = ({ image, imageOnly = false }) => {
    const [filterId] = useState(uniqueId('desaturate-grayscale-'));
    const [imageUrl, setImageUrl] = useState('');

    // detecting IE browser to load only svg
    const agent = typeof window !== 'undefined' && window.navigator.userAgent;
    const isIE11Browser =
        agent &&
        (agent.indexOf('MSIE') >= 0 ||
            (agent.indexOf('Trident') >= 0 && agent.indexOf('rv:11') >= 0));

    useEffect(() => {
        if (isIE11Browser) {
            const mediaUrlPrefix = /\/([-~]{1})\/media\//i;
            const match = mediaUrlPrefix.exec(image?.src);
            const newUrl = isNull(match)
                ? image?.src
                : image?.src.replace(mediaUrlPrefix, `/${match[1]}/jssmedia/`);
            setImageUrl(newUrl);
        }
    }, [image?.src]);

    return (
        <div
            className={classNames('DesaturateImage', {
                'DesaturateImage--absolute': imageOnly,
            })}>
            <div
                className={classNames('DesaturateImage__overlay', {
                    'DesaturateImage__overlay--image-only': imageOnly,
                })}
            />
            {isIE11Browser && imageUrl && (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="DesaturateImage__svg">
                    <defs>
                        <filter id={`${filterId}`}>
                            <feColorMatrix
                                type="matrix"
                                values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
                            />
                        </filter>
                    </defs>
                    <image
                        xlinkHref={imageUrl}
                        width="100%"
                        height="100%"
                        preserveAspectRatio="xMidYMid slice"
                        filter={`url(#${filterId})`}
                    />
                </svg>
            )}
            <Image
                src={image?.src}
                alt={image?.alt}
                classNames={{
                    img: 'DesaturateImage__img',
                    picture: 'h-full',
                }}
                sizes={[
                    {
                        w: 400,
                        media: '(max-width: 460px)',
                    },
                    {
                        w: 720,
                        media: '(min-width: 461px) and (max-width: 820px)',
                    },
                    {
                        media: '(min-width: 821px)',
                    },
                ]}
            />
        </div>
    );
};

DesaturateImage.propTypes = {
    image: PropTypes.shape({ src: PropTypes.string, alt: PropTypes.string })
        .isRequired,
    imageOnly: PropTypes.bool.isRequired,
};

export default DesaturateImage;
